/**
 * Dark mode is permanently enabled.
 * This hook exists as a single source of truth - if you ever need to
 * re-enable dark mode toggling, modify this file only.
 */
export const useDarkMode = (): boolean => true;

// Also export as constant for components that don't need a hook
export const IS_DARK_MODE = true;
